import ledImg from "@/assets/cc_img8_tennis.png";

const verbs = ["Watch", "Feel", "Play", "Share", "Remember"];

export function ExperienceEconomy() {
  return (
    <section id="why-now" className="relative py-32 overflow-hidden bg-arena">
      <img
        src={ledImg}
        alt=""
        aria-hidden
        width={1920}
        height={1080}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover opacity-20"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background/70 to-background" />
      <div className="absolute inset-0 led-grid opacity-20" />

      <div className="relative mx-auto max-w-6xl px-6">
        <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4">Why Now</p>
        <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl leading-[1.02] max-w-5xl">
          The <span className="line-through decoration-primary/60 decoration-[3px] text-muted-foreground">Content</span>{" "}
          Economy is being replaced by the{" "}
          <span className="text-gradient-ember">Experience Economy.</span>
        </h2>

        <div className="mt-12 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7 space-y-6 text-lg text-muted-foreground leading-relaxed">
            <p>
              For decades, companies competed for consumer attention with more content. More
              streaming. More social media. More highlights. More screens.
            </p>
            <p>
              Today, consumers have unlimited content available at all times. What they
              increasingly lack are meaningful experiences — moments they can feel, share,
              remember, and tell stories about.
            </p>
            <p>
              This shift is fueling growth across immersive attractions, destination
              entertainment, live events, competitive socializing, sports tourism, and
              experiential venues.
            </p>
            <p className="text-foreground">
              ClutchCube was built for this new reality. It does not ask fans to watch another
              highlight. <span className="text-gradient-ember font-semibold">It lets them become the highlight.</span>
            </p>
          </div>

          <div className="lg:col-span-5 space-y-8">
            <div className="border border-primary/30 bg-primary/5 rounded-sm p-8">
              <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4">Investor Thesis</p>
              <p className="font-display text-2xl leading-snug">
                The next generation of sports entertainment will not be watched.{" "}
                <span className="text-gradient-ember">It will be lived.</span>
              </p>
            </div>

            <div className="flex flex-wrap gap-2">
              {verbs.map((v, i) => (
                <span
                  key={v}
                  className={`px-4 py-2 text-sm uppercase tracking-[0.25em] rounded-sm border ${
                    i < 1
                      ? "border-border/60 bg-card text-muted-foreground line-through"
                      : "border-primary/40 bg-primary/10 text-foreground"
                  }`}
                >
                  {v}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
